import React from "react";
import NewsArticleLayout from "../../../components/updated-article/NewsArticleLayout.component";

const isNew = true;
const href = "/ratesheet/20250325-Rate-Sheet.pdf";
const date = "25.03.2025";

const Article = () => (
  <NewsArticleLayout href={href} date={date} isNew={isNew}>
    <h1 className="page-title">Changes to our mortgage products</h1>
    <p>With effect from Tuesday 25 March 2025 we will be making the following changes to our range:</p>
    <p>
      <strong>Summary of changes</strong>
    </p>
    <p>
      We are pleased to be introducing Premier Exclusive 2 and 5 Year Fixed fee paying and fee saver Buy to Let products
      at 60%, 65%, 75% and 80% LTV across our Purchase, Remortgage and Existing customer range.
    </p>
    <p>
      We have also reduced our cashback amount across our First Time Buyer, Homemover and Remortgage Residential EEH
      range.
    </p>
    <p>All Premier products are for existing HSBC Premier account holders only.</p>
    <p>There are no other changes to our interest rates.</p>
    <p>An updated mortgage rate sheet will be published on Tuesday 25 March 2025 to reflect these changes.</p>
  </NewsArticleLayout>
);

export default Article;
